module.exports = __webpack_public_path__ + "img/solid-background-map-hours-cjdr.61f6a02a.png";